import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';

const PrivateDocuments = ({ userId }) => {
  const [latest, setLatest] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form, setForm] = useState(() => {
    const o = {}; for (let i=1;i<=10;i++) o[i] = { name:'', valid_to:'', file:null }; return o;
  });

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/users/${userId}/private`);
      const map = {}; (data||[]).forEach(r => { map[r.slot] = r; });
      setLatest(map);
    } catch (e) {
      setError(e.message || 'Chyba pri načítaní');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  const setField = (slot, key, val) => setForm(prev => ({ ...prev, [slot]: { ...(prev[slot]||{}), [key]: val } }));

  const upload = async (slot) => {
    try {
      const d = form[slot];
      if (!d?.file) return alert('Vyberte súbor');
      if (d.file.size > 4 * 1024 * 1024) return alert('Max veľkosť súboru je 4 MB');
      const fd = new FormData();
      if (d.name) fd.append('name', d.name);
      if (d.valid_to) fd.append('valid_to', d.valid_to);
      fd.append('file', d.file);
      await api.post(`/users/${userId}/private/${slot}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert('Nahraté');
      setField(slot, 'file', null);
      setField(slot, 'name', '');
      setField(slot, 'valid_to', '');
      await load();
    } catch (e) {
      alert('Chyba: ' + (e.response?.data?.error || e.message));
    }
  };

  const onDownload = async (url, filename) => {
    try {
      const finalUrl = url ? url.replace(/(^https?:\/\/[^/]+)?\/(api\/)?uploads\//, '/uploads/') : url;
      const res = await fetch(finalUrl, { credentials: 'include' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const a = document.createElement('a'); const obj = URL.createObjectURL(blob);
      a.href = obj; a.download = filename || 'sukromny_dokument';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(()=>URL.revokeObjectURL(obj), 500);
    } catch (e) { alert('Chyba pri sťahovaní: ' + (e.message||'Neznáma chyba')); }
  };

  if (loading) return <div>Načítavam…</div>;
  if (error) return <div className="error">❌ {error}</div>;

  return (
    <div className="user-private-documents">
      <table className="documents-table">
        <thead>
          <tr>
            <th>Slot</th>
            <th>Názov</th>
            <th>Platnosť do</th>
            <th>Súbor</th>
            <th>Akcie</th>
            <th>Posledný súbor</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({length:10}, (_,i)=>i+1).map(slot => (
            <tr key={slot}>
              <td>{slot}</td>
              <td>
                <input type="text" value={form[slot]?.name||''} onChange={e=>setField(slot,'name',e.target.value)} placeholder="Názov (voliteľné)" />
              </td>
              <td>
                <input type="date" value={form[slot]?.valid_to||''} onChange={e=>setField(slot,'valid_to',e.target.value)} />
              </td>
              <td>
                <input type="file" onChange={e=> setField(slot,'file', e.target.files && e.target.files[0])} />
              </td>
              <td>
                <button type="button" onClick={()=> upload(slot)}>Nahrať</button>
              </td>
              <td>
                {latest[slot]?.download_url ? (
                  <button className="download-btn" style={{background:'none',border:'none',cursor:'pointer',padding:0}}
                          onClick={()=> onDownload(latest[slot].download_url, latest[slot].file_name)}>
                    stiahnuť
                  </button>
                ) : '—'}
                {latest[slot]?.valid_to ? (
                  <div style={{fontSize:'12px', color:'#495057'}}>Platnosť do: {new Date(latest[slot].valid_to).toLocaleDateString('sk-SK')}</div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrivateDocuments;
